module.exports = __webpack_public_path__ + "img/Business-Pulse-upgrade.5396d159.jpeg";